import React, { Component } from "react";
import PhotoGallery from "../../utils/PhotoGallery";

import '../noticiasEventos.css';

import{FormattedDate} from "react-intl";

const img = {
  width: "100%",
  marginBottom: "48px",
}

const texto = {
  fontSize: "16px",
  lineHeight: "40px",
  color: "#262626",
  marginBottom: "40px"
}

const date = {
  fontSize: "14px",
  color: "#262626",
  marginBottom: "48px"
}

class NoticiaDetalhes extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }


  componentWillReceiveProps(nextProps) {

    if(nextProps.noticia.insertionDate !== null){
      this.setState({newInsertionDate: nextProps.noticia.insertionDate});
    } else{
      this.setState({newInsertionDate: ""});
    }

  }


  render() {
    return (
      <React.Fragment>
        <div className="col-10 col-md-6">
          {this.props.noticia && (
            <img className="imagem-noticia" style={img} src={this.props.noticia.mainPhoto} alt="Imagem notícia" />
          )}
        </div>

        <div className="col-12">
          <p style={texto} dangerouslySetInnerHTML={{ __html: this.props.noticia.description }}></p>


          
          <p style={date} className="date"><span style={{fontWeight: 'bold'}}>Data de inserção: &nbsp;</span>
            <FormattedDate
              value={this.state.newInsertionDate}
              year='numeric'
              month='long'
              day='2-digit'
              />
          </p>
        </div>
        
        {this.props.noticia && this.props.noticia !== undefined && this.props.noticia.photos !== undefined && this.props.noticia.photos.length !== 0 && (
            <div className="container">
              <PhotoGallery photos={this.props.noticia.photos}></PhotoGallery>
            </div>
        )}
        

        
      </React.Fragment>
    );
  }
}

export default NoticiaDetalhes;
